import { render, staticRenderFns } from "./UpsertDealWrapper.vue?vue&type=template&id=5c66c1ef&lang=pug&"
import script from "./UpsertDealWrapper.vue?vue&type=script&lang=js&"
export * from "./UpsertDealWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports